import React, { Component} from 'react';
import {connect} from 'react-redux';

class DisputedLocation extends Component {
	constructor(props){
		super(props);
	}
	componentDidMount(){
		const { dispatch } = this.props;
	}
	render() {
		return (
			<div className = "root">
                <div className = "banner">Disputed Location</div>
			</div>
		);
	}
}

  
export default DisputedLocation;